import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const earlyTerminationRequest = async (params: {
  contractNumber: string;
  document: string;
}) => {
  const body = { number: params?.contractNumber, documentId: params?.document };
  const urlParams = new URLSearchParams(body);

  const response = await axiosInstance.post(
    `${REACT_APP_API_SERVER_URL}/api/contract/early-termination?${urlParams.toString()}`,
    body,
  );

  return response.status === 200;
};
